import router from "../../router";
import api from "../../api";
import { createError } from "../../libs/flash-messages";
import auth from "../../firebase/auth";

const state = {
   token: null,
   username: "",
   email: "",
   photoURL: "",
   isAdmin: false,
   loginError: "",
   loggingIn: false
}

const getters = {
   isLoggedIn(state) {
      return state.token ? true : false;
   },
   getUser(state) {
      return state;
   },
   getLoginError(state) {
      return state.loginError;
   },
   getToken(state) {
      return state.token;
   },
   getLoggingIn(state) {
      return state.loggingIn;
   }
}

const actions = {
   async createUser({ commit, dispatch }, data) {
      const token = data.token;
      try {
         const user = await api.axiosPostLog("/login", token);
         if (user) {
            commit("SET_TOKEN", token);
            commit('SET_USERNAME', data.displayName);
            commit('SET_EMAIL', data.mail);
            commit('SET_LOGIN_ERROR', "");
            if (user.isAdmin) {
               commit('SET_ISADMIN', true);
            }
            Promise.resolve("success")
            // don't push from here as this will deliver to home page any time you refresh the site
         } else {
            await auth.signOut();
            commit('SET_TOKEN', null);
            dispatch("creatLoginError", "You must be an active user on this site. Contact compliance for assistance getting access.")
            Promise.reject("login error")
            router.push("/login");
         }
      } catch (err) {
         createError("Failed to Fetch Users, Refresh and Try Again", err.response.data.error);
         return Promise.reject("login error")
      }
   },
   async checkToken(data) {
      try {
         // making any call to compliance to see if token is still valid
         await api.axiosPostLog("/verify", data);
         return Promise.resolve("token verified");
      } catch (err) {
         return Promise.reject(err.response.data.error);
      }
   },
   async startSetLoggingIn({ commit }, bool) {
      commit("SET_LOGGING_IN", bool);
   },
   async logOut({ commit }) {
      const status = await auth.signOut();
      if (status === "success") {
         commit('SET_USERNAME', "");
         commit('SET_EMAIL', "");
         commit('SET_PHOTOURL', "");
         commit('SET_LOGIN_ERROR', "");
         commit("SET_TOKEN", null);
         commit("SET_LOGGING_IN", false);
         if (router.currentRoute.path !== "/login") {
            router.push("/login");
         }
      } else {
         console.log(status);
      }
   },
   async startSetToken({ commit }, token) {
      commit('SET_TOKEN', token);
   },
   async createLoginError({ commit }, err) {
      createError("Couldn't sign you in", err);
      commit("SET_LOGIN_ERROR", "you must have a fbhl.com or fastforwardhomeloans.com address to login");
   },
   async SOCKET_COMP_UPDATE_LOGGED_USER({ commit, state }, user) {
      if (user.email === state.email) {
         if (!user.isActive) {
            const status = await auth.signOut();
            if (status === "success") {
               commit('SET_USERNAME', "");
               commit('SET_EMAIL', "");
               commit('SET_PHOTOURL', "");
               commit('SET_LOGIN_ERROR', "");
               commit("SET_TOKEN", null);
               return router.push("/login");
            }
         }
         if (user.isAdmin !== state.isAdmin) {
            commit("SET_ISADMIN", user.isAdmin);
         }
         Promise.resolve("success");
      }
   },
   async SOCKET_COMP_DELETE_LOGGED_USER({ commit, state }, user) {
      if (user.email === state.email) {
         const status = await auth.signOut();
         if (status === "success") {
            commit('SET_USERNAME', "");
            commit('SET_EMAIL', "");
            commit('SET_PHOTOURL', "");
            commit('SET_LOGIN_ERROR', "");
            commit("SET_TOKEN", null);
            return router.push("/login");
         }
      }
   }
}

const mutations = {
   SET_ISADMIN(state, bool) {
      state.isAdmin = bool;
   },
   SET_USERNAME(state, username) {
      return state.username = username
   },
   SET_EMAIL(state, email) {
      return state.email = email
   },
   SET_PHOTOURL(state, photourl) {
      return state.photoURL = photourl
   },
   SET_TOKEN(state, token) {
      return state.token = token;
   },
   SET_LOGIN_ERROR(state, msg) {
      return state.loginError = msg;
   },
   SET_LOGGING_IN(state, bool) {
      state.loggingIn = bool;
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}